// initial state
const state = {
  currencies: ['GBP']
}

export default {
  state
}
